import { useTranslation } from "react-i18next";

import { COMMON_NAMESPACE } from "@prostocheck/i18n";
import { cn } from "@prostocheck/shared";

import {
  BADGE_TONE_CLASS,
  CASH_REGISTER_STATE_LABEL_KEY,
  CASH_REGISTER_STATE_TONE,
  RECEIPT_TYPE_SHORT_LABEL_KEY,
  RECEIPT_TYPE_TONE,
} from "./badge.constants";
import {
  IBadgeProps,
  ICashRegisterBadgeProps,
  IReceiptTypeBadgeProps,
} from "./badge.models";

export const Badge = ({
  children,
  tone = "neutral",
  className,
}: IBadgeProps) => (
  <span
    className={cn(
      "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset",
      BADGE_TONE_CLASS[tone],
      className,
    )}
  >
    {children}
  </span>
);

export const CashRegisterBadge = ({ state }: ICashRegisterBadgeProps) => {
  const { t } = useTranslation(COMMON_NAMESPACE);

  return (
    <Badge tone={CASH_REGISTER_STATE_TONE[state]}>
      {t(CASH_REGISTER_STATE_LABEL_KEY[state])}
    </Badge>
  );
};

export const ReceiptTypeBadge = ({ type }: IReceiptTypeBadgeProps) => {
  const { t } = useTranslation(COMMON_NAMESPACE);

  return (
    <Badge tone={RECEIPT_TYPE_TONE[type]}>
      {t(RECEIPT_TYPE_SHORT_LABEL_KEY[type])}
    </Badge>
  );
};
